import { render, staticRenderFns } from "./Whatsapp.vue?vue&type=template&id=323eccb6&scoped=true"
var script = {}
import style0 from "./Whatsapp.scss?vue&type=style&index=0&id=323eccb6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323eccb6",
  null
  
)

export default component.exports